import React, { useState, useEffect } from "react";

export default function ModalWithIframe() {
    const [isOpen, setIsOpen] = useState(false);
    const toggleModal = () => setIsOpen(!isOpen);

    useEffect(() => {
        const style = document.createElement("style");
        style.textContent = `
            @keyframes pulse {
                0% { transform: scale(1); }
                50% { transform: scale(1.3); }
                100% { transform: scale(1); }
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <div style={{ padding: "16px" }}>
            <button
                onClick={toggleModal}
                style={{
                    backgroundColor: "#3b82f6",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    fontSize: 'large',
                    animation: "pulse 1s infinite",
                    zIndex: 9999,
                }}
            >
                Play a Game?
            </button>

            {isOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                        padding: 0,
                        margin: 0,
                        overflow: "hidden", // 重要
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            width: "100vw",      // ← 変更：画面幅ぴったりに
                            height: "100vh",     // ← 変更：画面高さぴったりに
                            overflow: 'auto',
                            borderRadius: "12px",
                            position: "relative",
                            overflow: "hidden",
                            boxShadow: "0 0 20px rgba(0, 0, 0, 0.2)",
                        }}
                    >
                        <button
                            onClick={toggleModal}
                            style={{
                                position: "absolute",
                                top: "16px",          // ← 閉じるボタン上に固定
                                right: "16px",
                                fontSize: "32px",
                                background: "none",
                                border: "none",
                                color: "red",
                                cursor: "pointer",
                                zIndex: 10000,
                            }}
                        >
                            ✕
                        </button>
                        <iframe
                            src="https://kokomo.kurikurikuricloud.com/"
                            title="外部ページ"
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                            }}
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
}
